module.exports = __webpack_public_path__ + "static/media/nestje5.88f199a3.jpg";